// extracted by mini-css-extract-plugin
export default {"container":"surveyConfirmation_container__Yuzz+","primary-button":"surveyConfirmation_primary-button__7-2JK","link":"surveyConfirmation_link__WSpAe"};